// src/components/LoadingSpinner.jsx
import React from "react";

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <p>Loading...</p> {/* You can replace this with a spinner or skeleton UI */}
  </div>
);

export default LoadingSpinner;